import { setAuthCookiesFromUrl } from './utils/auth';

setAuthCookiesFromUrl();
